// Build & Version
let version     = '7.19';
let build       = "26.10.27.1"; // YY.M.D.#

/*
To Release
fab releaseWebApp --build=26.8.26.1 --comment="MISC PATCHES"
fab releaseWebApp --build=26.4.29.2 --comment="FIX"
 */

module.exports = {
    version             : version,
    build               : build,
    releaseMomentUTC    : '2026-07-20 04:00:00'         // used to determine when to show new release
};

/** Put history below this line - DO NOT REMOVE/MODIFY this comment */
// 26.10.27.1    - Fixes: #54016, #54020, #54053, #54054, #54055, #54134;
// 26.10.26.1    - 7.next-project-automation-universal (#38429);
// 26.10.22.1    - Fixes: #52726;
// 26.10.21.2    - Fixes: #52688;
// 26.10.21.1    - Fixes: #52686;
// 26.10.20.4    - 7.next-customer-profile(b) (#51361);
// 26.10.20.3    - 7.next-customer-profile (#51361);
// 26.10.20.2    - Fixes: #51818(b);
// 26.10.20.1    - Fixes: #51728, #51818;
// 26.10.19.1    - Fixes: #51807, #51809;
// 26.10.16.1    - Fixes: #50295 (b);
// 26.10.15.3    - Fixes: #50458;
// 26.10.15.2    - Fixes: #50017;
// 26.10.15.1    - Fixes: #50294, #50295; 7.next-mcp; 7.next-gantt-linked-tasks; 7.next-automations-date-arives;
// 26.10.13.1    - Fixes: #50290, #49929; 7.next-automation-add-remove-to-project (#50288);  patch-tag-access-mode(#48952);
// 26.10.12.1    - Fixes: #50101;
// 26.10.9.1    - Fixes: #50280;
// 26.10.8.1    - Fixes: #49966(b);
// 26.10.7.3    - Fixes: #50007(b);
// 26.10.7.2    - Fixes: #49966; 7.18-time-report-extended-entities-meeting-view
// 26.10.7.1    - Fixes: #50007;
// 26.10.6.1    - Fixes: #49963; #49992; version change to 7.19;
// 26.10.5.2    - Fixes: #49960;
// 26.10.5.1    - Fixes: #31826;
// 26.10.2.2    - Fixes: #49939;
// 26.10.2.1    - Fixes: #31390;
// 26.9.1.3    - Fixes: #35524(b);
// 26.9.1.2    - Fixes: #49154;
// 26.9.1.1    - Fixes: #29917, #35524;
// 26.9.29.2    - Fixes: #48959;
// 26.9.29.1    - Fixes: #49115;
// 26.9.28.2    - Fixes: #47991(b), #48962;
// 26.9.28.1    - Fixes: #46981, #47991, #48938, #48939, #48950;
// 26.9.25.2    - Fixes: #47989;
// 26.9.25.1    - 7.next-fue-upgrade-artur (#47991); 7.next-task-type-upgrade (#46009);
// 26.9.24.1    - Fixes: #47987;
// 26.9.23.3    - Fixes: #41832(b);
// 26.9.23.2    - Fixes: #41832;
// 26.9.23.1    - Fixes: #47031;
// 26.9.22.3    - Fixes: #29570;
// 26.9.22.2    - 7.next-fue-upgrade-artur (b);
// 26.9.22.1    - 7.next-fue-upgrade-artur; Fixes: #45334;
// 26.9.18.2    - Fixes: #22493;
// 26.9.18.1    - Fixes: #46949;
// 26.9.14.1    - 7.next-goals-export-to-csv; Fixes: #44781;
// 26.9.11.2    - Fixes: #44142;
// 26.9.11.1    - Fixes: #44104;
// 26.9.10.3    - Fixes: #44122;
// 26.9.10.2    - Fixes: #43787;
// 26.9.10.1    - Fixes: #43786;
// 26.9.9.1    - 7.next-settings-task-type-required-fields;
// 26.9.3.1    - Fixes: #41825;
// 26.9.2.2    - Fixes: #41831;
// 26.9.2.1    - Fixes: #41142;
// 26.8.31.1    - Fixes: #32996, #39776, #41136;
// 26.8.26.1    - MISC PATCHES
// 26.8.14.2    - webhooks
// 26.8.14.1    - Shared View: resolve skin paths via assetsPath;
// 26.8.13.5    - icons fix;
// 26.8.13.4    - Task view messages fixes;
// 26.8.13.3    - vic fixes;
// 26.8.13.2    - 7.next-support-ticket-system;
// 26.8.13.1    - 7.next-project-tags-scope;
// 26.8.12.3    - Fixes: #36338;
// 26.8.12.2    - Fixes: #37616;
// 26.8.12.1    - Fixes: #36328;
// 26.8.11.1    - Fixes: #37591;
// 26.8.7.2    - Fixes: #37246;
// 26.8.7.1    - Fixes: #37241;
// 26.8.6.1    - Fixes: #36677, #36680; 7.next-task-view-update;
// 26.8.5.1    - 7.next-related-items-entity-selector;
// 26.8.4.1    - Fixes: #36365;
// 26.8.3.2    - Typescript -> 5.9 + Some fixes;
// 26.8.3.1    - Fixes: #36343;
// 26.7.31.3    - 7.next-status-system-status-change;
// 26.7.31.2    - Fixes: #35526;
// 26.7.31.1    - Fixes: #35853;
// 26.7.30.4    - 7.17 release
// 26.7.30.3    - 7.17
// 26.7.30.3    - 7.17
// 26.7.30.2    - Fixes: #35850;
// 26.7.30.1    - Fixes: #35843, #35849;
// 26.7.29.2    - Fixes: #35832; 7.next-project-settings-upgrade;
// 26.7.29.1    - 7.next-task-whiteboard-support(b);
// 26.7.28.3    - 7.next-task-whiteboard-support;
// 26.7.28.2    - 7.next-dashboard-lifecycle-widgets-2;
// 26.7.28.1    - 7.next-pricing-plan-issues;
// 26.7.27.2    - Fixes: #35537;
// 26.7.27.1    - Fixes: #35001; 7.next-user-info-make-admin;
// 26.7.24.3    - graphql fix
// 26.7.24.2    - 7.next-task-actions-2;
// 26.7.24.1    - Fixes: #35508;
// 26.7.23.2    - Fixes: #33678, #35030, #35031;
// 26.7.23.1    - 7.next-real-time-line-chart-widget(b);
// 26.7.22.1    - 7.next-real-time-line-chart-widget;
// 26.7.21.1    - Fixes: #34981;
// 26.7.20.2    - Fixes: #33000;
// 26.7.20.1    - Fixes: #34981;
// 26.7.17.1    - Fixes: #34974; 7.next-my-work-views;
// 26.7.15.1    - Fixes: #34924;
// 26.7.14.2    - 7-next-formula-new-implementation (b);
// 26.7.14.1    - 7-next-formula-new-implementation;
// 26.7.13.1    - Fixes: #32999; 7.next-status-changed-condition (b);
// 26.7.10.1    - Fixes: #34862; 7.next-status-changed-condition;
// 26.7.9.1    - Fixes: #33577b;
// 26.7.7.2    - Fixes: #31827, #33543;
// 26.7.7.1    - Fixes: #32997b, #32394;
// 26.7.6.3    - Fixes: #32997, #33577;
// 26.7.6.2    - Fixes: #33066;
// 26.7.6.1    - Fixes: #32992;
// 26.7.2.2    - Fixes: #33563;
// 26.7.2.1    - 7.next-task-reply-via-email; Fixes: #31374;
// 26.7.1.3    - 7.next-bulk-task-users-action;
// 26.7.1.2    - Fixes: #33017, #33070, #33534;
// 26.7.1.1    - Fixes: #32431, #33019b;
// 26.6.30.1    - Fixes: #32372, #33019, #33065;
// 26.6.29.4    - Fixes: #33057;
// 26.6.29.3    - Fixes Vic
// 26.6.29.2    - Fixes: #32996;
// 26.6.29.1    - Fixes: #33016, #33020, #33024, #33031;
// 26.6.26.1    - Fixes: #33013, #33015;
// 26.6.25.2    - Fixes: #31808;
// 26.6.25.1    - 7.next-my-time-upgrade-v6; Fixes: #32428, #32976, #32979;
// 26.6.23.1    - Fixes: #32373, #32433, #32380, #32381;
// 26.6.18.1    - vic-multi-user-selector;
// 26.6.17.1    - bulk add/remove task user
// 26.6.15.1    - Fixes: #31843;
// 26.6.12.2    - v 7.15 release
// 26.6.12.1    - 7.15
// 26.6.8.2    - Fixes: 31761;
// 26.6.8.1    - Fixes: 31739;
// 26.6.5.3    - Skin version changed to 5.32;
// 26.6.5.2    - Fixes: #31567;
// 26.6.5.1    - Fixes: #31720;
// 26.6.4.3    - 7.next-task-notification;
// 26.6.4.2    - Fixes: #31638; 7.next-task-notification; 7.next-resources-graphql;
// 26.6.4.1    - Fixes: #31670, #31679, #31685;
// 26.6.3.1    - Fixes: #31698; 7.next-resources-graphql;
// 26.6.2.2    - Fixes: #31651;
// 26.6.2.1    - 7.next-resources-graphql;
// 26.6.1.1    - Fixes: #31638, #31660;
// 26.5.29.2    - Fixes: #31615b;
// 26.5.29.1    - Fixes: #31628b;
// 26.5.28.2    - Fixes: #31615, #31628;
// 26.5.28.1    - Fixes: #31518, #31620, #31622, #31624; 7.next-project-automation;
// 26.5.27.2    - version: 7.14
// 26.5.27.1    - 7.7-task-side-view-v5-align-test;
// 26.5.22.3    - Fixes: #29829, #31549;
// 26.5.22.2    - Fixes: #26593;
// 26.5.22.1    - Fixes: #28582;
// 26.5.18.1    - Fixes: #29961;
// 26.5.15.1    - Fixes: #30280;
// 26.5.13.2    - 7.next-task-type;
// 26.5.13.1    - Fixes: #31374;
// 26.5.12.1    - Fixes: #30278;
// 26.5.11.2    - 7.next-asana-fix-arthur; Settings: AI AiAgentsQuickLinks is commented out;
// 26.5.11.1    - 7.next-ai-agents;
// 26.5.7.1    - Fixes: #30182, #30219;
// 26.5.6.1    - Fixes: #30206; 7.14-calude-dashbord-project-widgets-mykola;
// 26.5.4.1    - Fixes: #30179;
// 26.4.29.2    - FIX
// 26.4.29.1    - Navigation SpaceSettings fix;
// 26.4.27.1    - Fixes: #30114;
// 26.4.24.1    - Fixes: #30072;
// 26.4.23.1    - Fixes: #30044;
// 26.4.22.3    - Fixes: #29845;
// 26.4.22.2    - Fixes: #29711;
// 26.4.22.1    - Fixes: #30012;
// 26.4.20.2    - AI beta release
// 26.4.20.1    - Fixes: #29207;
// 26.4.16.3    - Fixes: #29908;
// 26.4.16.2    - 7.next-project-automation;
// 26.4.16.1    - Fixes: #29670;
// 26.4.15.2    - Fixes: #29911b, #29918;
// 26.4.15.1    - Fixes: #29911, #29912;
// 26.4.14.1    - Fixes: #29892, #29893; 7.next-task-in-multiple-projects-automations;
// 26.4.13.1    - Fixes: #29859;
// 26.4.10.3    - Fixes: #28826, #29656;
// 26.4.10.2    - Fixes: #25961;
// 26.4.10.1    - Fixes: #29828 #29830; 7.8-todo-list-module-session-delta;
// 26.4.9.2    - Fixes: #29576;
// 26.4.9.1    - Fixes: #29704, #29804, #29813;
// 26.4.7.2    - Fixes: #29782;
// 26.4.7.1    - Fixes: #29559;
// 26.4.3.2    - Fixes: #29719;
// 26.4.3.1    - Fixes: #29692, #29700;
// 26.4.2.2    - fix-ai-reply;
// 26.4.2.1    - Fixes: #29698;
// 26.4.1.1    - Fixes: #29637; 7.next-asana-import-sections;
// 26.3.30.2    - write with AI;
// 26.3.30.1    - Fixes: #29631, #29634;
// 26.3.27.2    - Fixes: #29577;
// 26.3.27.1    - Fixes: #29564;
// 26.3.26.2    - Fixes: #29557;
// 26.3.26.1    - Fixes: #29537, #29545;
// 26.3.25.3    - Fixes: #29517;
// 26.3.25.2    - 7.8-LIST-3;
// 26.3.25.1    - Fixes: #27638;
// 26.3.23.1    - Fixes: #29454;
// 26.3.20.2    - Fixes: #29104;
// 26.3.20.1    - Fixes: #29196, #29409;
// 26.3.19.3    - Fixes: #29408;
// 26.3.19.2    - Fixes: #29189, #29349;
// 26.3.19.1    - Fixes: #29380;
// 26.3.18.1    - Fixes: #29218;
// 26.3.16.1    - Fixes: #29258;
// 26.3.13.3    - Fixes: #29247;
// 26.3.13.2    - Fixes: #29241;
// 26.3.13.1    - Fixes: #29208;
// 26.3.12.2    - Fixes: #29227;
// 26.3.12.1    - Fixes: #29207;
// 26.3.11.1    - dashboard templates and new add view menu
// 26.3.10.1    - Fixes: #29187;
// 26.3.9.1    - Fixes: #29142; 7.next-new-add-menu;
// 26.3.6.4    - Fixes: #29122;
// 26.3.6.3    - Fixes: #29116c;
// 26.3.6.2    - Fixes: #29116b;
// 26.3.6.1    - Fixes: #29116; 7.8-change-theme-without-reload; 7.next-project-summary-view;
// 26.3.5.3    - Fixes: #29102;
// 26.3.5.2    - Fixes: #29065, #29079, #29080;
// 26.3.5.1    - Fixes: #29082;
// 26.3.4.1    - Fixes: #28989, #29075;
// 26.3.3.3    - Fixes: #29048, #29060;
// 26.3.3.2    - Fixes: #28837b;
// 26.3.3.1    - Fixes: #28837, #29043;
// 26.3.2.1    - 7.next-task-via-email;
// 26.2.27.3    - Fixes: #29018b;
// 26.2.27.2    - Fixes: #29005, #29018; 7.next-my-tasks-upgrade;
// 26.2.27.1    - Menu teams; GD Modules: List TaskListSortingManager updateSorting fix;
// 26.2.26.4    - Model2: ItemModel ItemCalculatedValuesAdapter fix;
// 26.2.26.3    - Fixes: #28953;
// 26.2.26.2    - 7.7-BOARD-3;
// 26.2.26.1    - Fixes: #28983;
// 26.2.25.1    - patch-modern-skin-navbar-separator;
// 26.2.23.4    - 7.8
// 26.2.23.3    - Fixes: #28945;
// 26.2.23.2    - Fixes: #28944; 7.next-goodday-modern-skin-v2;
// 26.2.23.1    - Fixes: #28801, #28940;
// 26.2.20.5    - 7.next-goodday-modern-skin-v2 (b);
// 26.2.20.4    - 7.next-goodday-modern-skin-v2;
// 26.2.20.3    - Fixes: #28909; 7.7-bulk-task-duplicate (b);
// 26.2.20.2    - 7.7-bulk-task-duplicate;
// 26.2.20.1    - Fixes: #28631; Workload tiny design fix;
// 26.2.19.2    - Fixes: #28893;
// 26.2.19.1    - Fixes: #28887;
// 26.2.18.2    - Fixes: #28870; 7.next-task-view-links;
// 26.2.18.1    - Fixes: #28857, #28864;
// 26.2.17.3    - Fixes: #28830, #28846;
// 26.2.17.2    - Fixes: #28825;
// 26.2.17.1    - Fixes: #28756, #28796b, #28798;
// 26.2.16.2    - Fixes: #28822;
// 26.2.16.1    - Fixes: #27595b, #28509, #28698, #28747, #28796;
// 26.2.13.2    - Fixes: #28662;
// 26.2.13.1    - Fixes: #28362, #28685, #28744, #28746;
// 26.2.12.5    - bug fix
// 26.2.12.4    - Fixes: #28744;
// 26.2.12.3    - Release 7.7-TABLE-RC1;
// 26.2.12.2    - Tasks: #27908;
// 26.2.12.1    - Fixes: #28699;
// 26.2.11.1    - Fixes: #28722;
// 26.2.10.1    - Fixes: #28703;
// 26.2.9.1    - Fixes: #28674;
// 26.2.6.1    - 7.next-my-work-upgrade-v2 (2);
// 26.2.5.3    - 7.next-my-work-upgrade-v2;
// 26.2.5.2    - Fixes: #28655;
// 26.2.5.1    - Fixes: #28643b;
// 26.2.4.1    - Fixes: #28643; 7.next-ai-chat
// 26.1.30.1    - Fixes: #28578;
// 26.1.29.1    - Fixes: #28585;
// 26.1.26.3    - Fixes: #28507b;
// 26.1.26.2    - Fixes: #28507;
// 26.1.26.1    - Fixes: #27595, #28482;
// 26.1.23.5    - Fixes: #28479;
// 26.1.23.4    - Fixes: #28502;
// 26.1.23.3    - 7.7-more-spaces-list fix 2;
// 26.1.23.2    - 7.7-more-spaces-list DND fix revert
// 26.1.23.1    - 7.7-more-spaces-list DND fixes;
// 26.1.22.2    - Fixes: #26570, #27421; GD Modules: Task List SidePanelNavigation and TaskListGroupEmpty some refactoring (typescript);
// 26.1.22.1    - Fixes: #28213;
// 26.1.21.2    - Fixes: #28448;
// 26.1.21.1    - Fixes: #28295;
// 26.1.20.2    - 7.7-more-spaces-list;
// 26.1.20.1    - Fixes: #26508;
// 26.1.19.2    - Fixes: #28397;
// 26.1.19.1    - 7.7-automation-create-task-dependency
// 26.1.16.2    - Fixes: #28383;
// 26.1.16.1    - 7.7-automation-create-task-dependency;
// 26.1.15.2    - Fixes: #27567b;
// 26.1.15.1    - Fixes: #27567;
// 26.1.14.1    - Fixes: #28354;
// 26.1.13.1    - Fixes: #28341;
// 26.1.8.1    - Fixes: #28169;
// 26.1.6.1    - Fixes: #28123;
// 26.1.5.1    - Fixes: #28127;
// 25.12.23.1    - Fixes: #27969;
// 25.12.16.2    - Fixes: #27874;
// 25.12.16.1    - 7.next-report-lifecycle-time;
// 25.12.15.2    - Fixes: #27232;
// 25.12.15.1    - Fixes: #27824;
// 25.12.5.1    - Fixes: #27672b;
// 25.12.4.2    - 7.next-delete-users-upgrade
// 25.12.4.1    - 7.next-delete-users-upgrade
// 25.12.2.1    - Fixes: #27636;
// 25.12.1.1    - Fixes: #27634, #27672; 7.6-delete-users-time-reports;
// 25.11.28.1    - deleted users
// 25.11.26.2    - start end filter field
// 25.11.26.1    - Fixes: #27567c;
// 25.11.25.2    - Fixes: #27567b;
// 25.11.25.1    - Fixes: #27567, #27609;
// 25.11.24.2    - Fixes: #27603;
// 25.11.24.1    - Fixes: #23800, #27583, #27568;
// 25.11.20.1    - small fixes
// 25.11.19.1    - desktop app news
// 25.11.18.1    - Fixes: #27553, #27556;
// 25.11.17.3    - Fixes: #27523;
// 25.11.17.2    - Fixes: #27507;
// 25.11.17.1    - 7.next-deleted-users-page;
// 25.11.15.3    - Teams release try 3
// 25.11.15.2    - Teams release try 2
// 25.11.15.1    - Teams release
// 25.11.14.1    - Fixes: #27449;
// 25.11.13.2    - auto clockout time
// 25.11.13.1    - Fixes: #27434;
// 25.11.12.1    - Fixes: #27420;
// 25.11.11.1    - Import monday
// 25.11.10.5    - CRM fixes + 7.5 version
// 25.11.10.4    - CRM fixes
// 25.11.10.3    - new fix
// 25.11.10.2    - new-navigation skin
// 25.11.10.1    - Fixes: #27324;
// 25.11.6.1    - desktop app
// 25.11.4.1    - Project Table: update fields on add custom field fix;
// 25.11.3.1    - Fixes: #27189, #27197;
// 25.10.31.3    - Fixes: #26915;
// 25.10.31.2    - Setup: more sentry messages (on each setup screen);
// 25.10.31.1    - Fixes: #27140, #27141;
// 25.10.29.2    - Fixes: #26714; Setup-sentry-messages fix;
// 25.10.29.1    - Setup-sentry-messages
// 25.10.28.2    - Fixes: #26855;
// 25.10.28.1    - Fixes: #26888;
// 25.10.27.2    - Fixes: #26838;
// 25.10.27.1    - Fixes: #26833, #26842, #26848;
// 25.10.24.1    - Fixes: #26839;
// 25.10.22.2    - Workload fixes;
// 25.10.22.1    - Fixes: #26817;
// 25.10.21.1    - Project Board: scroll tiny fix;
// 25.10.20.1    - Fixes: #26762;
// 25.10.17.3    - Fixes: #26770;
// 25.10.17.2    - Views: loadResources fix;
// 25.10.17.1    - Fixes: #26765;
// 25.10.16.1    - 7.2-filters-upgrade-v7
// 25.10.15.1    - 7.5-session-reset-refactoring
// 25.10.14.1    - 7.next-crm-bulk-actions
// 25.10.13.3    - Fixes: #26711;
// 25.10.13.2    - Fixes: #24905b;
// 25.10.13.1    - Fixes: #26686;
// 25.10.10.2    - setup fix
// 25.10.10.1    - Fixes: #26551b;
// 25.10.9.2    - Fixes: #26561;
// 25.10.9.1    - Fixes: #24905, #26657;
// 25.10.8.1    - presence connect v3
// 25.10.7.1    - Fixes: #26182;
// 25.10.6.1    - UI5: ui5-group ui5-arrow-toggle-9 fix; GD Modules: PrintVersionTaskList fix;
// 25.10.3.1    - Fixes: #25737b;
// 25.10.1.1    - Fixes: #26417, #26551;
// 25.9.30.1    - Fixes: #26057;
// 25.9.26.1    - session events fixes
// 25.9.23.1    - Fixes: #25737;
// 25.9.22.1    - 7.4
// 25.9.19.5    - fix
// 25.9.19.4    - project users collection
// 25.9.19.3    - Fabric: upload progress;
// 25.9.19.2    - Fabric test
// 25.9.19.1    - 7.next-project-summary-upgrade
// 25.9.18.1    - Project users
// 25.9.15.2    - Fixes: #26286;
// 25.9.15.1    - Fixes: #26263, #26318; 7.next-users-update; 7.4-task-description-history;
// 25.9.11.2    - Presence v2
// 25.9.11.1    - Fixes: #26284, #26285, #26298;
// 25.9.10.1    - automation comment on task
// 25.9.8.1    - project info release
// 25.9.5.2    - line chart in category charts
// 25.9.5.1    - line chart in category charts
// 25.9.3.2     - Fixes: #26186;
// 25.9.3.1     - Fixes: #26235;
// 25.9.2.2     - Fixes: #26164, #26185;
// 25.9.2.1     - Fixes: #25932b, #26219, #26113, #26152, #26165;
// 25.9.1.3     - Fixes: #26075, #26155;
// 25.9.1.2     - Fixes: #25737, #25932, #25937, #26184;
// 25.9.1.1     - Fixes: #26156;
// 25.8.21.2    - demo users fixes
// 25.8.21.1    - whiteboard release
// 25.8.20.2    - test fab release
// 25.8.20.1    - fix org edit profile
// 25.8.19.1    - Patch date custom field value
// 25.8.18.2    - Patch date custom field value
// 25.8.18.1    - 7.3 Release
// 25.8.13.4    - 7.3-Setup;
// 25.8.13.3    - Fixes: #26014;
// 25.8.13.2    - Fixes: #26016, #26022, #26048;
// 25.8.13.1    - Fixes: #25838, #25967;
// 25.8.11.1    - spaces templates
// 25.8.8.1     - Fixes: #25982;
// 25.8.7.2     - Fixes: #25970;
// 25.8.7.1     - Fixes: #25939, #25966;
// 25.8.6.2     - Fixes: #25377;
// 25.8.6.1     - Fixes: #25933; 7.Next-timeline; 7.0-my-tasks; 7.4-list-flat-UI;
// 25.8.5.2     - Fixes: #25922;
// 25.8.5.1     - Fixes: #25924; some warning fixes;
// 25.8.4.2     - Fixes: #25884b;
// 25.8.4.1     - Fixes: #25870, #25875b, #25911;
// 25.8.1.2     - Fixes: #25871, #25872, #25875, #25884;
// 25.8.1.1     - Fixes: #25777; Quick Add: Task CustomFields fix;
// 25.7.29.4    - 7.x-dashboard-custom-field-conditions-3;
// 25.7.29.3    - Project Info: SectionInfo timeReported fix;
// 25.7.29.2    - GD UI: AddViewPopover onClickOutside fix;
// 25.7.29.1    - 7.2-project-info-fields;
// 25.7.25.2    - Fixes: #25819;
// 25.7.25.1    - Fixes: #25793;
// 25.7.24.1    - Fixes: #25494;
// 25.7.23.2    - GD Modules: List first item TaskListTitleCellCorners fix;
// 25.7.23.1    - Fixes: #25440b, #25784, #25785, #25786;
// 25.7.22.4    - Fixes: #25790b;
// 25.7.22.3    - Fixes: #25789, #25790;
// 25.7.22.2    - Fixes: #25440, #25775, #25776;
// 25.7.22.1    - Fixes: #25772;
// 25.7.21.1    - Fixes: #25726, #25737;
// 25.7.17.4    - Fixes: #25676;
// 25.7.17.3    - Fixes: #25724;
// 25.7.17.2    - Fixes: #25713;
// 25.7.17.1    - Fixes: #25668, #25609, #25685; 7.next-projects-list-presets
// 25.7.15.3    - GD Modules: AddColumn SearchResults fix; GD Modules: Document DocumentsTitleFieldComponent more fix;
// 25.7.15.2    - task chart fix;
// 25.7.15.1    - 7.x-automation-create-task-fields
// 25.7.14.5    - updated dashboard and charts
// 25.7.14.4    - 7.2 release
// 25.7.14.3    - Fixes: #25609, #25639;
// 25.7.14.2    - Fixes: #25621b;
// 25.7.14.1    - Fixes: #25621;
// 25.7.11.1    - 7.next-new-custom-fields
// 25.7.10.2    - Fixes: #25493; 7.next-new-custom-fields
// 25.7.10.1    - Fixes: #25599;
// 25.7.9.6     - Fixes: #25601b;
// 25.7.9.5     - Fixes: #25601;
// 25.7.9.4     - Fields: CustomFieldForm onSubmit displayName fix;
// 25.7.9.3     - Fixes: #25593;
// 25.7.9.2     - Fixes: #25450;
// 25.7.9.1     - Fixes: #25512b, #25592;
// 25.7.8.3     - maps
// 25.7.8.2     - Fixes: #25494;
// 25.7.8.1     - Fixes: #25574, #25586;
// 25.7.7.7     - Skin version 5.31
// 25.7.7.6     - 7.2-project-summary-view;
// 25.7.7.5     - 7.2 prerelease + time reports
// 25.7.7.4     - 7.2 pre-release
// 25.7.7.3     - ReUpload;
// 25.7.7.2     - Fixes: #25446;
// 25.7.7.1     - Fixes: #25526; 7.3-gdrive-fix;
// 25.7.4.2     - GD Modules: Table updateListItemsWidth on resize;
// 25.7.4.1     - Workspaces: update on session full reset fix;
// 25.7.2.1     - Fixes: #25507, #25508, #25509, #25512;
// 25.6.30.2    - Fixes: #25498;
// 25.6.30.1    - Fixes: #25458;
// 25.6.27.3    - icons
// 25.6.27.2    - Fixes: #25384 (#25455);
// 25.6.27.1    - Fixes: #25459, #25445;
// 25.6.26.2    - GD Modals: ModalAddUser_Right long title design fix;
// 25.6.26.1    - Fixes: #25438, #25442, #25444;
// 25.6.25.2    - 7.1
// 25.6.25.1    - Fixes: #25429; 7.1-SECTION-MENU;
// 25.6.24.1    - Fixes: #25424, #25427;
// 25.6.23.2    - fix-connection-presense
// 25.6.23.1    - Fixes: #25403, #25407; Attachments: ui5-attachment-no-preview-small small fix;
// 25.6.20.1    - Fixes: #25404; Layout Menu: NavigationMenuItemAddCommon is refactored;
// 25.6.19.1    - Fixes: #25386, #25391;
// 25.6.18.4    - Fixes: #25319, #25372, #25373b; 7.1-workload-display-hours-in-weelky;
// 25.6.18.3    - Fixes: #25371, #25373;
// 25.6.18.2    - Fixes: #25375b;
// 25.6.18.1    - Fixes: #25375, #25376;
// 25.6.17.1    - Fixes: #25356, #25367; 7.1-current-view-portfolio;
// 25.6.16.3    - QuickSearch improvements and fixes;
// 25.6.16.2    - 7.1 SILENT release
// 25.6.16.1    - Fixes: #25327;
// 25.6.13.2    - Fixes: #25331;
// 25.6.13.1    - Fixes: #25297, #25326;
// 25.6.12.1    - 7.1-custom-report;
// 25.6.11.1    - GD Modals: task link small design fix;
// 25.6.10.2    - Fixes: #25228;
// 25.6.10.1    - Fixes: #25301;
// 25.6.6.2     - Fixes: #25264;
// 25.6.6.1     - Fixes: #25253; 7.1-portfolio-display-numbers; 7.1-collapse-expand-in-menu;
// 25.6.5.1     - Fixes: #24759, #25240; 7.0-daily-report;
// 25.6.4.4     - Task view: css fix;
// 25.6.4.3     - Fixes: #25180;
// 25.6.4.2     - Fixes: #25230; Layout: Projects reset manual sorting fix;
// 25.6.4.1     - Fixes: #25224; 7.1-autofocus-to-search-input;
// 25.6.3.2     - GD Modals: ModalMoveTo_NoResultsFound fix 2;
// 25.6.3.1     - Fixes: #25217; GD Modals: ModalMoveTo_NoResultsFound fix;
// 25.6.2.1     - Fixes: #25197;
// 25.5.30.1    - Views: Projects list DND fix;
// 25.5.29.1    - Fixes: #25158, #25162; Project Info: Users onItemDeleteClick immediately remove item is implemented;;
// 25.5.28.2    - Fixes: #25117;
// 25.5.28.1    - Fixes: #25134, #25135;
// 25.5.27.2    - 7.0 release
// 25.5.27.1    - Fixes: #25091, #25114, #25121; 7.0-v8-health-settings;
// 25.5.26.2    - GD Modals: ModalAddUser_Right showCompanyUsers fix;
// 25.5.26.1    - hide archived pins ...
// 25.5.23.5    - Session: SessionProjectNew skip events from different company; GD Modals: Add users canAddCompanyUsers check is implemented;
// 25.5.23.4    - GD Model: ProjectUsers resetByProject fix; Task View: mentions save to local storage fix (User.toJSON() is implemented);
// 25.5.23.3    - Task View: ReplyFormOpen onSubmit fix; Layout: Menu Standard access add view fix;
// 25.5.23.2    - 7.0-v8;
// 25.5.23.1    - Fixes: #25079;
// 25.5.16.1    - Fixes: #24989 (task 24986);
// 25.5.14.3    - 6.23
// 25.5.14.2    - Fixes: #24957;
// 25.5.14.1    - Fixes: #24920;
// 25.5.13.2    - 6.29-asana-import fix;
// 25.5.13.1    - Fixes: #24948; 6.29-asana-import;
// 25.5.12.1    - Fixes: #24915;
// 25.5.8.1     - Fixes: #24875;
// 25.5.6.2     - Fixes: #24884;
// 25.5.6.1     - 6.29-conflict-new
// 25.5.2.1     - GD: API Request resendRequest and ajaxRequestV2 fix (for print-2-pdf as it has no gd.auth);
// 25.5.1.1     - 6.29-auth-fixes;
// 25.4.30.1    - Fixes: #24765; 6.29-auth-fixes;
// 25.4.29.1    - new auth engine
// 25.4.28.5    - Fixes: #24781;
// 25.4.28.4    - Fixes: #24814b;
// 25.4.28.3    - Fixes: #24814;
// 25.4.28.2    - Fixes: #24795;
// 25.4.28.1    - Fixes: #24769;
// 25.4.25.2    - Fixes: #24772;
// 25.4.25.1    - Fixes: #24755;
// 25.4.24.2    - Fixes: #24757;
// 25.4.24.1    - Fixes: #24754;
// 25.4.23.3    - Fixes: #23410;
// 25.4.23.2    - 6.next-project-type-field
// 25.4.23.1    - Fixes: #24699;
// 25.4.21.2    - My Tasks: MyTasksLocalSettings groupBy2 fix;
// 25.4.21.1    - 6.next-calendar-view-project;
// 25.4.18.3    - Fixes: #24675b;
// 25.4.18.2    - Fixes: #24675;
// 25.4.18.1    - Fixes: #24669, #24671;
// 25.4.17.4    - Fixes: #24656;
// 25.4.17.3    - Fixes: #24655;
// 25.4.17.2    - Fixes: #24496;
// 25.4.17.1    - Fixes: #24630, #24639;
// 25.4.16.1    - 6.Next-group-by;
// 25.4.15.1    - Fixes: #24526;
// 25.4.14.2    - Fixes: #24555;
// 25.4.14.1    - Fixes: #24525;
// 25.4.10.1    - Fixes: #24532;
// 25.4.9.2     - Fixes: #24509;
// 25.4.9.1     - Fixes: #24494;
// 25.4.8.2     - 6.22
// 25.4.8.1     - Fixes: #24488;
// 25.4.7.1     - Fixes: #24457;
// 25.4.1.3     - Fixes: #24399;
// 25.4.1.2     - new icons cache fix;
// 25.4.1.1     - new icons;
// 25.3.30.1    - Saved reports
// 25.3.27.1    - 6.22-icons;
// 25.3.26.2    - Fixes: #24152;
// 25.3.26.1    - Fixes: #24148, #24149;
// 25.3.25.3    - Custom Views: Calendar, Gantt, Board, Workload Preferences save fix;
// 25.3.25.2    - Fixes: #24138;
// 25.3.25.1    - Fixes: #24132;
// 25.3.24.2    - Fixes: #24079;
// 25.3.24.1    - Fixes: #24078;
// 25.3.22.1    - 6.21
// 25.3.21.3    - 6.19-VIEW-IN-STRUCTURE-2;
// 25.3.21.2    - Fixes: #24069
// 25.3.21.1    - Fixes: #24077, #24086;
// 25.3.20.1    - Fixes: #23775;
// 25.3.18.1    - Fixes: #24054;
// 25.3.17.1    - Fixes: #23950;
// 25.3.13.1    - Fixes: #23929;
// 25.3.12.2    - Fixes: #23947;
// 25.3.12.1    - Fixes: #23927;
// 25.3.9.4     - Fixes: #23914;
// 25.3.9.3     - Request Forms: fixes;
// 25.3.9.2     - GD Modules: Task List Quick Filter system status fix;
// 25.3.9.1     - Fixes: 23879;
// 25.3.7.3     - 6.20 (reports) + automations condition
// 25.3.7.2     - Fixes: #23552;
// 25.3.7.1     - Fixes: #23604, #23851, #23858;
// 25.3.6.1     - Fixes: #23815;
// 25.3.5.1     - 6.17-click-up-import-fast instruction added;
// 25.3.4.2     - 6.17-click-up-import-fast fix;
// 25.3.4.1     - 6.17-click-up-import-fast
// 25.2.28.2    - Workload and Shared Calendar fixes;
// 25.2.28.1    - Fixes: #23729;
// 25.2.27.1    - Gantt small fixes, shared view board custom view fix;
// 25.2.26.2    - Link in Structure: edit source and click fix;
// 25.2.26.1    - Fixes: #23701;
// 25.2.24.1    - Fixes: #23687;
// 25.2.19.1    - Fixes: #23596, #23600;
// 25.2.17.1    - Fixes: #23559;
// 25.2.14.2    - Fixes: #23531; 6.next-my-work-more-menu
// 25.2.14.1    - 6.Next-report-timer
// 25.2.13.3    - 6.19
// 25.2.13.2    - Fixes: #23557;
// 25.2.13.1    - Fixes: #23533, #23544;
// 25.2.12.1    - Fixes: #23539;
// 25.2.11.4    - Fixes: #23525c;
// 25.2.11.3    - Fixes: #23534, #23536;
// 25.2.11.2    - Fixes: #23525b;
// 25.2.11.1    - Fixes: #23482, #23525;
// 25.2.10.1    - Fixes: #23398, #23513;
// 25.2.6.4     - Fields3: FieldSelectField_Popover convertFieldsStructureToConfig fix;
// 25.2.6.3     - Fixes: #23458;
// 25.2.6.2     - 6.17-REPORTS-RC1;
// 25.2.6.1     - 6.next-Gantt, 6.next-MULTISORT-RC1;
// 25.2.5.2     - Fixes: #22440; 6.16-attachment-custom-field
// 25.2.5.1     - Fixes: #22746;
// 25.2.4.3     - Add api key from google
// 25.2.4.2     - 6.next-CUSTOM-FIELDS-RC1, 6.Next-page-subpages-2
// 25.2.4.1     - 6.Next-clickup-markdown-conversion
// 25.2.3.2     - Page: disabled small fix;
// 25.2.3.1     - 6.Next-page-subpages
// 25.1.31.1    - Fixes: #25056;
// 25.1.28.2    - 6.18
// 25.1.28.1    - Fixes: #25046;
// 25.1.24.2    - Fixes: #25015, #25019, #25021;
// 25.1.24.1    - Fixes: #24913, #24980;
// 25.1.22.2    - 6.17-add-view;
// 25.1.22.1    - Fixes: #24988, #24990;
// 25.1.16.3    - Fixes: #24935;
// 25.1.16.2    - 6.17-PROJECT-VIEWS-RC1
// 25.1.16.1    - Fixes: #24929;
// 25.1.15.2    - 6.17
// 25.1.15.1    - Fixes: #24901;
// 25.1.14.1    - Fixes: #24876, #24883;
// 25.1.13.1    - Fixes: #24848;
// 25.1.10.1    - 6.17-VALIDATIONS-RC1; Fixes: #24381;
// 25.1.8.3     - Trash
// 25.1.8.2     - Fixes: #24680;
// 25.1.8.1     - Fixes: #24507, #24797;
// 25.1.7.1     - 6.16
// 24.12.27.1   - Fixes: #24691;
// 24.12.25.1   - Expenses release
// 24.12.24.2   - Fixes: #24655;
// 24.12.24.1   - Fixes: #24651;
// 24.12.23.1   - Fixes: #24602;
// 24.12.18.2   - Fixes: #24543;
// 24.12.18.1   - Fixes: #24581;
// 24.12.13.1   - Fixes: #24557;
// 24.12.12.1   - 6.XXX-Bulk-action-selector-with-shift;
// 24.12.10.2   - Fixes: #24494;
// 24.12.10.1   - Fixes: #24457;
// 24.12.9.1    - Fixes: #24491;
// 24.12.4.2    - GD Modules: Gantt rows numeration order fix;
// 24.12.4.1    - Fixes: #24446;
// 24.12.2.1    - Fixes: #24434;
// 24.11.29.1   - GD UI: ReorderListNoDiv useLayoutEffect fix (isEqual is slow in Projects menu);
// 24.11.28.1   - GD Modules: Table/List customer onClick item fix;
// 24.11.27.2   - 6.14
// 24.11.27.1   - Fixes: #24400;
// 24.11.26.2   - Fixes: 6.14-AUTOMATIONS-RC1;
// 24.11.26.1   - Fixes: #24369;
// 24.11.25.3   - Fixes: #24249;
// 24.11.25.2   - Fixes: #24283;
// 24.11.25.1   - Fixes: #24377;
// 24.11.22.2   - Fixes: patch-support-ticket;
// 24.11.22.1   - Fixes: #24182;
// 24.11.20.3   - GD Settings: gd.table renderMode default value is modified;
// 24.11.20.2   - Fixes: #21380;
// 24.11.20.1   - Fixes: #23749; GD Components: HoverComponent fix; 6.14-Performance-table-virtualized;
// 24.11.19.1   - Fixes: #24339, #24304;
// 24.11.18.2   - Custom Entities
// 24.11.18.1   - Fixes: #24315;
// 24.11.14.2   - Fixes: #24310;
// 24.11.14.1   - Fixes: #24270;
// 24.11.13.3   - 6.13
// 24.11.13.2   - Performance patch + enabl;e community access
// 24.11.13.1   - Fixes: #24287; 6.13-documents;
// 24.11.8.3    - patch
// 24.11.8.2    - Fixes: #24223;
// 24.11.8.1    - Fixes: #23639, #24127;
// 24.11.7.1    - 6.12
// 24.11.6.2    - 6.12
// 24.11.6.1    - Fixes: #24117, #24202;
// 24.11.5.2    - Fields3: FieldMultiselect_TableCell onOptionClick hidePopover property is added, FieldMultiselect_TableCellValue update fix;
// 24.11.5.1    - 6.12-TAGS-RC1;
// 24.10.31.2   - 6.14-project-page-update-fix;
// 24.10.31.1   - Fixes: #24108;
// 24.10.29.2   - Fixes: #24111;
// 24.10.29.1   - Fixes: #24102;
// 24.10.28.2   - 6.12-workload-reports;
// 24.10.28.1   - Fixes: #24100;
// 24.10.25.1   - Fixes: #24078;
// 24.10.23.5   - Fixes: #24038;
// 24.10.23.4   - Fixes: #23596;
// 24.10.23.3   - Fixes: #24030b;
// 24.10.23.2   - Fixes: #24030, #24037;
// 24.10.23.1   - Fixes: #22737;
// 24.10.22.1   - Fixes: #24033;
// 24.10.21.1   - Fixes: #23723;
// 24.10.18.5   - Fixes: #23748c;
// 24.10.18.4   - 6.11
// 24.10.18.3   - Fixes: #23748b;
// 24.10.18.2   - Fixes: #23645, #23748, #23750;
// 24.10.18.1   - Fixes: #23738, #23743, #23744;
// 24.10.17.3   - Fixes: #23735;
// 24.10.17.2   - after merge;
// 24.10.17.1   - 6.10-link-embed-RC1;
// 24.10.16.1   - Fixes: #23708, #23712;
// 24.10.14.3   - Fixes: #23681;
// 24.10.14.2   - Fixes: #23680;
// 24.10.14.1   - Fixes: 6.11-WORSCHEDULE-RC1;
// 24.10.11.3   - Fixes: #23589, #23640, #23641, #23642, #23644;
// 24.10.11.2   - Fixes: #23592d;
// 24.10.11.1   - Fixes: #23592c;
// 24.10.10.4   - Fixes: #23592b;
// 24.10.10.3   - Fixes: #23622;
// 24.10.10.2   - copy task users
// 24.10.10.1   - Fixes: #23592;
// 24.10.9.2    - Fixes: #23588;
// 24.10.9.1    - Fixes: #23601;
// 24.10.7.3    - 6.10 release
// 24.10.7.2    - Fixes: #23561;
// 24.10.7.1    - Fixes: #23550;
// 24.10.2.5    - Fixes: #23513;
// 24.10.2.4    - Fixes: #23458;
// 24.10.2.3    - Fixes: #23505;
// 24.10.2.2    - Fixes: #23486b;
// 24.10.2.1    - Fixes: #22102b, #23486;
// 24.10.1.3    - 6.10-task-view-action-buttons;
// 24.10.1.2    - Fixes: #23467b;
// 24.10.1.1    - Fixes: #23450;
// 24.9.30.2    - Fixes: #23466;
// 24.9.30.1    - Fixes: #23467; 6.11-growl-new-design;
// 24.9.25.1    - Fixes: #22903; 6.10-project-view-management;
// 24.9.24.1    - Fixes: #22506, #22745;
// 24.9.23.3    - Fixes: #23403;
// 24.9.23.2    - Fixes: #23363;
// 24.9.23.1    - Fixes: #23377;
// 24.9.20.2    - Fixes: #23361b;
// 24.9.20.1    - Fixes: #23359, #23361;
// 24.9.19.5    - 6.9
// 24.9.19.4    - Fixes: #23351;
// 24.9.19.3    - Fixes: #23350;
// 24.9.19.2    - Fixes: #23093;
// 24.9.19.1    - Fixes: #22102;
// 24.9.18.2    - Fixes: #23084;
// 24.9.18.1    - Fixes: #22805;
// 24.9.17.2    - Fixes: #22926, #22927;
// 24.9.17.1    - Fixes: #22745, #22920;
// 24.9.16.1    - Fixes: #22875, 6.6-page;
// 24.9.11.1    - Fixes: #22743;
// 24.9.10.1    - Fixes: #22713, #22738;
// 24.9.6.4     - disable sentry by default
// 24.9.6.3     - fix table less errors
// 24.9.6.2     - fix Calendar
// 24.9.6.1     - Fixes: #22678, #22679, #22707;
// 24.9.5.3     - 6.8
// 24.9.5.2     - Fixes: #22706;
// 24.9.5.1     - Fixes: #20268b;
// 24.9.4.2     - Fixes: #22668;
// 24.9.4.1     - Fixes: #22656, #22669;
// 24.9.3.2     - Fixes: #22603, #22664;
// 24.9.3.1     - Fixes: #22622, #22642
// 24.9.2.2     - Fixes: #22646;
// 24.9.2.1     - 6.9-time-report-limits;
// 24.8.30.1    - Fixes: #22149;
// 24.8.23.1    - Fixes: #22205b;
// 24.8.22.1     - gCal msCal sync release
// 24.8.21.2    - Fixes: #22481;
// 24.8.21.1    - Fixes: #21892, #22513;
// 24.8.19.1    - Fixes: #22351, #22495;
// 24.8.16.3    - Clock In
// 24.8.16.2    - 6.7 release
// 24.8.16.1    - Fixes: #22487;
// 24.8.14.1    - add view menu
// 24.8.13.3    - GD: PermissionsCustomView getAllAvailable fix;
// 24.8.13.2    - 6.7-Clock-In-Out fixes;
// 24.8.13.1    - 6.7-Clock-In-Out;
// 24.8.12.3    - Fixes: #20268b;
// 24.8.12.2    - Fixes: #20268;
// 24.8.12.1    - Fixes: #22412;
// 24.8.8.1     - Fixes: #22379;
// 24.8.6.1     - 6.6
// 24.8.5.1     - Fixes: #21035, #22336;
// 24.8.1.1     - All projects;
// 24.7.31.1    - Fixes: #22046;
// 24.7.30.1    - Fixes: #22199;
// 24.7.29.1    - Fixes: #21892;
// 24.7.25.1    - fix create project non manager
// 24.7.24.1    - Fixes: #22205;
// 24.7.23.2    - Fixes: #22181;
// 24.7.23.1    - Fixes: #22123;
// 24.7.22.1    - Fixes: #22162, #22166;
// 24.7.18.2    - webhook history
// 24.7.18.1    - Fixes: #22098;
// 24.7.16.1    - isBillable time
// 24.7.15.1    - Fixes: #22056;
// 24.7.11.1    - Fixes: #21962, #21981;
// 24.7.10.2    - Fixes: #21982;
// 24.7.10.1    - Fixes: #21994;
// 24.7.8.1     - Fixes: #21930; fixes from 6.4-performance;
// 24.7.6.1     - Hourly cost history
// 24.7.5.2     - Fixes: #21929;
// 24.7.5.1     - Fixes: #21849, #21884, #21892;
// 24.7.4.1     - Fixes: #21819;
// 24.7.2.1     - Fixes: #21863;
// 24.6.25.1    - patch
// 24.6.21.1    - beta release 6.5
// 24.6.10.1    - 6.4 - Goals release
// 24.6.7.1     - Fixes: #21623;
// 24.6.6.1     - Fixes: #21604;
// 24.6.5.1     - Fixes: #20003, #21575;
// 24.6.3.1     - Fixes: #21461, #21573;
// 24.5.31.2    - Fixes: #21540;
// 24.5.31.1    - merged with 6.3-goals;
// 24.5.28.1    - merged with 6.3-goals;
// 24.5.24.2    - merged with 6.3-goals;
// 24.5.24.1    - Fixes: #21465;
// 24.5.23.1    - merged with 6.3-goals;
// 24.5.21.1    - Fixes: #21426;
// 24.5.20.2    - Fixes: #21374;
// 24.5.20.1    - Fixes: #21400;
// 24.5.15.2    - Snapshots gantt improvemnt
// 24.5.15.1    - Fixes: #21264, #21268;
// 24.5.13.1    - Fixes: #21178, #21202, #21246;
// 24.5.6.1     - ui5: popover menu css fix;
// 24.4.30.2    - 6.3
// 24.4.30.1    - Fixes: #19613;
// 24.4.22.1    - Fixes: #20999;
// 24.4.19.1    - Fixes: #20206, #20998, #21001;
// 24.4.17.2    - Fixes: #20894b;
// 24.4.17.1    - Fixes: #20894;
// 24.4.16.1    - Fixes: #20959, #20961;
// 24.4.11.2    - Fixes: Task View: reply onSubmit fix;
// 24.4.11.1    - Fixes: #20272;
// 24.4.10.1    - Fixes: #19916, #20189, #20259, #20263, #20264;
// 24.4.5.1     - Fixes: #20191;
// 24.4.3.1     - Fixes: #20123b;
// 24.4.2.3     - Fixes: #20123;
// 24.4.2.2     - Fixes: #20118b;
// 24.4.2.1     - Fixes: #20118;
// 24.4.1.2     - 6.2
// 24.4.1.1     - Fixes: #20075; 6.1-chats
// 24.3.30.1    - time reports by task type
// 24.3.29.1    - Fixes: #20037;
// 24.3.28.3    - task message delete reaction api call change
// 24.3.28.2    - 6.2-session-reset-fix
// 24.3.28.1    - Fixes: #19979, #20030;
// 24.3.27.1    - automations addons
// 24.3.26.1    - Fixes: #19824;
// 24.3.22.1    - Fixes: #19916, #19927, #19946, #19961;
// 24.3.21.1    - 6.1
// 24.3.20.1    - checkout promo code
// 24.3.18.3    - Fixes: #19751c;
// 24.3.18.2    - Fixes: #19751b;
// 24.3.18.1    - Fixes: #19751;
// 24.3.15.2    - Fixes: #19408, #19836;
// 24.3.15.1    - Fixes: #19828;
// 24.3.14.1    - Fixes: #19511, #19762;
// 24.3.12.2    - Fixes: #19755;
// 24.3.12.1    - Fixes: #19581;
// 24.3.11.1    - Fixes: #18004, #19710;
// 24.3.7.3     - AppTaskView: taskView_logView is reverted;
// 24.3.7.2     - AppTaskView: taskView_logView is commented out;
// 24.3.7.1     - 6.1-task-view-log
// 24.3.6.2     - Fix login warning + MESSAGE REACTIONS !
// 24.3.6.1     - Fixes: #19652;
// 24.3.5.1     - 2fa personal
// 24.2.29.2    - Fixes setting links (Vic);
// 24.2.29.1    - Fixes: #19531, #19537, #19539;
// 24.2.28.1    - Fixes: #19364;
// 24.2.26.4    - Fixes: #19504, organization delete user app refactor;
// 24.2.26.3    - Fixes: #19350, #19417, #19491, #19494;
// 24.2.25.2    - micro
// 24.2.25.1    - 6.0 (Vic)


